// ----------------------------------------------------------------------------
// Snippet: Newsletter Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/icon/icon';

// Styles
import './_newsletter-form.scss';